import { render, staticRenderFns } from "./CityGroupEdit.vue?vue&type=template&id=574b2e63&scoped=true"
import script from "./CityGroupEdit.vue?vue&type=script&lang=js"
export * from "./CityGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./CityGroupEdit.vue?vue&type=style&index=0&id=574b2e63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574b2e63",
  null
  
)

export default component.exports